{
  "Check out the support documentation for more details.": [
    {
      "type": 0,
      "value": "Check out the support documentation for more details."
    }
  ],
  "Dismiss": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "Looking to enhance the agent experience?": [
    {
      "type": 0,
      "value": "Looking to enhance the agent experience?"
    }
  ],
  "Not now": [
    {
      "type": 0,
      "value": "Not now"
    }
  ],
  "Show me": [
    {
      "type": 0,
      "value": "Show me"
    }
  ],
  "Show me the apps": [
    {
      "type": 0,
      "value": "Show me the apps"
    }
  ],
  "Upgrade options": [
    {
      "type": 0,
      "value": "Upgrade options"
    }
  ],
  "We've curated a list for you of the best marketplace apps to boost agent productivity!": [
    {
      "type": 0,
      "value": "We've curated a list for you of the best marketplace apps to boost agent productivity!"
    }
  ],
  "We've made some changes to imports": [
    {
      "type": 0,
      "value": "We've made some changes to imports"
    }
  ],
  "We’re having trouble with your plan": [
    {
      "type": 0,
      "value": "We’re having trouble with your plan"
    }
  ],
  "We’ve kept you on the Standard plan of Confluence for now.": [
    {
      "type": 0,
      "value": "We’ve kept you on the Standard plan of Confluence for now."
    }
  ],
  "We’ve put you on the Free plan of Confluence for now. You can add up to 10 users.": [
    {
      "type": 0,
      "value": "We’ve put you on the Free plan of Confluence for now. You can add up to 10 users."
    }
  ],
  "confluence-3p-connector-nudge.action.connect": [
    {
      "type": 0,
      "value": "Connect now"
    }
  ],
  "confluence-3p-connector-nudge.action.learnMore": [
    {
      "type": 0,
      "value": "Learn more"
    }
  ],
  "confluence-3p-connector-nudge.description": [
    {
      "type": 0,
      "value": "You've been using "
    },
    {
      "type": 1,
      "value": "providerName"
    },
    {
      "type": 0,
      "value": " in "
    },
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 0,
      "value": ". Connect it to get richer previews and better search."
    }
  ],
  "confluence-3p-connector-nudge.title": [
    {
      "type": 0,
      "value": "Connect "
    },
    {
      "type": 1,
      "value": "providerName"
    }
  ],
  "feedback-collector.can-be-enrolled-label.text": [
    {
      "type": 0,
      "value": "Atlassian can contact me about this feedback. See our"
    },
    {
      "type": 1,
      "value": "nbsp"
    },
    {
      "children": [
        {
          "type": 0,
          "value": "privacy policy"
        }
      ],
      "type": 8,
      "value": "privacyPolicyLink"
    }
  ],
  "feedback-collector.enroll-in-research-label.text": [
    {
      "type": 0,
      "value": "I'd like to help improve Atlassian products by joining the"
    },
    {
      "type": 1,
      "value": "nbsp"
    },
    {
      "type": 1,
      "value": "n"
    },
    {
      "type": 1,
      "value": "t"
    },
    {
      "type": 1,
      "value": "t"
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Atlassian Research Group"
        }
      ],
      "type": 8,
      "value": "enrollLink"
    }
  ],
  "feedback-collector.feedback-title-details.component": [
    {
      "type": 0,
      "value": "For help with billing or other issues, visit our"
    },
    {
      "type": 1,
      "value": "nbsp"
    },
    {
      "children": [
        {
          "type": 0,
          "value": "documentation"
        }
      ],
      "type": 8,
      "value": "documentationLink"
    },
    {
      "type": 1,
      "value": "nbsp"
    },
    {
      "type": 0,
      "value": "or contact"
    },
    {
      "type": 1,
      "value": "nbsp"
    },
    {
      "children": [
        {
          "type": 0,
          "value": "support"
        }
      ],
      "type": 8,
      "value": "supportLink"
    }
  ],
  "no-notifications-fallback.learn-more-link.text": [
    {
      "type": 0,
      "value": "Learn more about this feature"
    }
  ],
  "no-notifications-fallback.no-notifications.text": [
    {
      "type": 0,
      "value": "Check back soon. No notifications yet."
    }
  ],
  "notifications.error-fallback-error-reason.text": [
    {
      "type": 0,
      "value": "We're unable to load notifications"
    }
  ],
  "notifications.error-fallback-proposed-solution.text": [
    {
      "type": 0,
      "value": "Refresh the page or try again later"
    }
  ],
  "post-office-team.confluence-recommended-following-feed.add-comment-button": [
    {
      "type": 0,
      "value": "Comment"
    }
  ],
  "post-office-team.confluence-recommended-following-feed.add-emoji-button-alt-text": [
    {
      "type": 0,
      "value": "Add Emoji"
    }
  ],
  "post-office-team.confluence-recommended-following-feed.ai-use-disclaimer": [
    {
      "type": 0,
      "value": "Uses AI. Verify results."
    }
  ],
  "post-office-team.confluence-recommended-following-feed.ai-use-disclaimer-alt-text": [
    {
      "type": 0,
      "value": "Information icon"
    }
  ],
  "post-office-team.confluence-recommended-following-feed.atlassian-logo": [
    {
      "type": 0,
      "value": "Atlassian Logo"
    }
  ],
  "post-office-team.confluence-recommended-following-feed.blog-icon": [
    {
      "type": 0,
      "value": "Blog icon"
    }
  ],
  "post-office-team.confluence-recommended-following-feed.clap-button-alt-text": [
    {
      "type": 0,
      "value": "Clap"
    }
  ],
  "post-office-team.confluence-recommended-following-feed.database-icon": [
    {
      "type": 0,
      "value": "Database icon"
    }
  ],
  "post-office-team.confluence-recommended-following-feed.email-unsubscribe-text": [
    {
      "children": [
        {
          "type": 0,
          "value": "Update your email settings"
        }
      ],
      "type": 8,
      "value": "trackedLink"
    },
    {
      "type": 0,
      "value": " to customize or stop receiving this email."
    }
  ],
  "post-office-team.confluence-recommended-following-feed.email.body.hello": [
    {
      "type": 0,
      "value": "G'day "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "post-office-team.confluence-recommended-following-feed.email.body.summary": [
    {
      "type": 0,
      "value": "Here are pages your team is reading, don't miss out on the conversation."
    }
  ],
  "post-office-team.confluence-recommended-following-feed.email.ios-android-text": [
    {
      "type": 0,
      "value": "Download the Confluence mobile app on "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "iOS"
        }
      ],
      "type": 8,
      "value": "iosLink"
    },
    {
      "type": 0,
      "value": " or "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Android"
        }
      ],
      "type": 8,
      "value": "androidLink"
    },
    {
      "type": 0,
      "value": " to read notifications and comment on the go."
    }
  ],
  "post-office-team.confluence-recommended-following-feed.email.privacy-policy-text": [
    {
      "type": 0,
      "value": "This email was sent by Atlassian Confluence  •  "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Privacy policy"
        }
      ],
      "type": 8,
      "value": "privacyPolicyLink"
    }
  ],
  "post-office-team.confluence-recommended-following-feed.email.subject": [
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ", your team is working on these pages -- join the conversation"
    }
  ],
  "post-office-team.confluence-recommended-following-feed.email.subject.variant-a": [
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ", "
    },
    {
      "type": 1,
      "value": "pageTitle"
    },
    {
      "type": 0,
      "value": " plus more pages your team is working on"
    }
  ],
  "post-office-team.confluence-recommended-following-feed.header.confluence-icon.alt-text": [
    {
      "type": 0,
      "value": "Confluence Icon"
    }
  ],
  "post-office-team.confluence-recommended-following-feed.name-user-reacted": [
    {
      "children": [
        {
          "type": 1,
          "value": "firstUser"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " reacted"
    }
  ],
  "post-office-team.confluence-recommended-following-feed.name-user-reacted-and-number-of-others": [
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "children": [
                {
                  "type": 1,
                  "value": "firstUser"
                },
                {
                  "type": 0,
                  "value": " and "
                },
                {
                  "type": 1,
                  "value": "calculatedReactionCount"
                },
                {
                  "type": 0,
                  "value": " other"
                }
              ],
              "type": 8,
              "value": "strong"
            },
            {
              "type": 0,
              "value": " reacted"
            }
          ]
        },
        "other": {
          "value": [
            {
              "children": [
                {
                  "type": 1,
                  "value": "firstUser"
                },
                {
                  "type": 0,
                  "value": " and "
                },
                {
                  "type": 1,
                  "value": "calculatedReactionCount"
                },
                {
                  "type": 0,
                  "value": " others"
                }
              ],
              "type": 8,
              "value": "strong"
            },
            {
              "type": 0,
              "value": " reacted"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "calculatedReactionCount"
    }
  ],
  "post-office-team.confluence-recommended-following-feed.name-users-reacted": [
    {
      "children": [
        {
          "type": 1,
          "value": "firstUser"
        },
        {
          "type": 0,
          "value": " and "
        },
        {
          "type": 1,
          "value": "secondUser"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " reacted"
    }
  ],
  "post-office-team.confluence-recommended-following-feed.name-users-reacted-and-number-of-others": [
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "children": [
                {
                  "type": 1,
                  "value": "firstUser"
                },
                {
                  "type": 0,
                  "value": ", "
                },
                {
                  "type": 1,
                  "value": "secondUser"
                },
                {
                  "type": 0,
                  "value": ", and "
                },
                {
                  "type": 1,
                  "value": "calculatedReactionCount"
                },
                {
                  "type": 0,
                  "value": " other"
                }
              ],
              "type": 8,
              "value": "strong"
            },
            {
              "type": 0,
              "value": " reacted"
            }
          ]
        },
        "other": {
          "value": [
            {
              "children": [
                {
                  "type": 1,
                  "value": "firstUser"
                },
                {
                  "type": 0,
                  "value": ", "
                },
                {
                  "type": 1,
                  "value": "secondUser"
                },
                {
                  "type": 0,
                  "value": ", and "
                },
                {
                  "type": 1,
                  "value": "calculatedReactionCount"
                },
                {
                  "type": 0,
                  "value": " others"
                }
              ],
              "type": 8,
              "value": "strong"
            },
            {
              "type": 0,
              "value": " reacted"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "calculatedReactionCount"
    }
  ],
  "post-office-team.confluence-recommended-following-feed.no-comments": [
    {
      "type": 0,
      "value": "Be the first to comment"
    }
  ],
  "post-office-team.confluence-recommended-following-feed.no-reactions-text": [
    {
      "type": 0,
      "value": "Be the first to react"
    }
  ],
  "post-office-team.confluence-recommended-following-feed.number-of-comments": [
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "children": [
                {
                  "type": 7
                }
              ],
              "type": 8,
              "value": "strong"
            },
            {
              "type": 0,
              "value": " comment"
            }
          ]
        },
        "other": {
          "value": [
            {
              "children": [
                {
                  "type": 7
                }
              ],
              "type": 8,
              "value": "strong"
            },
            {
              "type": 0,
              "value": " comments"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "commentCount"
    }
  ],
  "post-office-team.confluence-recommended-following-feed.number-of-users-reacted": [
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "children": [
                {
                  "type": 1,
                  "value": "reactionCount"
                }
              ],
              "type": 8,
              "value": "strong"
            },
            {
              "type": 0,
              "value": " reacted"
            }
          ]
        },
        "other": {
          "value": [
            {
              "children": [
                {
                  "type": 1,
                  "value": "reactionCount"
                }
              ],
              "type": 8,
              "value": "strong"
            },
            {
              "type": 0,
              "value": " reacted"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "reactionCount"
    }
  ],
  "post-office-team.confluence-recommended-following-feed.owned-by": [
    {
      "type": 0,
      "value": "Owned by "
    },
    {
      "type": 1,
      "value": "ownerName"
    }
  ],
  "post-office-team.confluence-recommended-following-feed.party-popper-button-alt-text": [
    {
      "type": 0,
      "value": "Party Popper"
    }
  ],
  "post-office-team.confluence-recommended-following-feed.read-more-link": [
    {
      "type": 0,
      "value": "Read more"
    }
  ],
  "post-office-team.confluence-recommended-following-feed.thumbs-up-button-alt-text": [
    {
      "type": 0,
      "value": "Thumbs up"
    }
  ],
  "post-office-team.confluence-recommended-following-feed.user-profile-picture-alt-text": [
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": "'s profile picture"
    }
  ],
  "post-office-team.confluence-recommended-following-feed.whiteboard-icon": [
    {
      "type": 0,
      "value": "Whiteboard icon"
    }
  ],
  "post-office-team.email-with-tracking-links.message-template-template.email.body.img.alt.no-translate": [
    {
      "type": 0,
      "value": "Description of image"
    }
  ],
  "post-office-team.email-with-tracking-links.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Post Office Test Message from "
    },
    {
      "type": 1,
      "value": "env"
    }
  ],
  "post-office-team.email-with-tracking-links.test-message.email.body.hello.no-translate": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "post-office-team.email-with-tracking-links.test-message.email.body.no-translate": [
    {
      "type": 0,
      "value": "This is a test message from the "
    },
    {
      "type": 1,
      "value": "env"
    },
    {
      "type": 0,
      "value": " environment."
    }
  ],
  "post-office-team.email-with-tracking-links.test-message.email.body.regards.no-translate": [
    {
      "type": 0,
      "value": "Team Post Office"
    }
  ],
  "post-office-team.email-with-tracking-links.test-message.email.body.signoff.no-translate": [
    {
      "type": 0,
      "value": "Regards,"
    }
  ],
  "post-office-team.email-with-tracking-links.test-message.email.confluence-link.text.no-translate": [
    {
      "type": 0,
      "value": "Go to Confluence link"
    }
  ],
  "post-office-team.email-with-tracking-links.test-message.email.jira-link.text.no-translate": [
    {
      "type": 0,
      "value": "Go to Jira link"
    }
  ],
  "post-office-team.email-with-tracking-links.test-message.email.trello-link.text.no-translate": [
    {
      "type": 0,
      "value": "Go to Trello board"
    }
  ],
  "post-office-team.push-msg-object-tracking.message-template-template.email.body.img.alt.no-translate": [
    {
      "type": 0,
      "value": "Description of image"
    }
  ],
  "post-office-team.push-msg-object-tracking.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Post Office Test Message from "
    },
    {
      "type": 1,
      "value": "env"
    }
  ],
  "post-office-team.push-msg-object-tracking.message-template.microsoft-teams.hello-message.no-translate": [
    {
      "type": 0,
      "value": "Hello, *This is notification test from post office*"
    }
  ],
  "post-office-team.push-msg-object-tracking.test-message.email.body.hello.no-translate": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "post-office-team.push-msg-object-tracking.test-message.email.body.no-translate": [
    {
      "type": 0,
      "value": "This is a test message from the "
    },
    {
      "type": 1,
      "value": "env"
    },
    {
      "type": 0,
      "value": " environment."
    }
  ],
  "post-office-team.push-msg-object-tracking.test-message.email.body.regards.no-translate": [
    {
      "type": 0,
      "value": "Team Post Office"
    }
  ],
  "post-office-team.push-msg-object-tracking.test-message.email.body.signoff.no-translate": [
    {
      "type": 0,
      "value": "Regards,"
    }
  ],
  "post-office-team.push-msg-object-tracking.test-message.email.unsubscribe.text.no-translate": [
    {
      "type": 0,
      "value": "Unsubscribe"
    }
  ],
  "post-office.admin-hub.end-of-notifications.description": [
    {
      "type": 0,
      "value": "That's all your notifications from the last 90 days"
    }
  ],
  "post-office.post-office-team-components.email.footer.copyright": [
    {
      "type": 0,
      "value": "Copyright "
    },
    {
      "type": 1,
      "value": "year"
    },
    {
      "type": 0,
      "value": " Atlassian Pty Ltd. All rights reserved."
    }
  ],
  "post-office.post-office-team-components.email.footer.office-address": [
    {
      "type": 0,
      "value": "We are located at 341 George Street, Sydney, NSW, 2000, Australia"
    }
  ],
  "post-office.post-office-team-components.email.footer.why-am-i-receiving-this-email": [
    {
      "type": 0,
      "value": "You are receiving this email because this is an important message regarding your account and products you are using. You are not allowed to unsubscribe from this type of message."
    }
  ],
  "post-office.post-office-team.jira-messaging-research-recruitment.screen-space-flags.cta-link": [
    {
      "type": 0,
      "value": "Get started"
    }
  ],
  "post-office.post-office-team.jira-messaging-research-recruitment.screen-space-flags.description": [
    {
      "type": 0,
      "value": "Help us improve messaging for Atlassian Admins! Answer a few short questions, and our\n\t\t\t\t\tResearch team will contact you for a 60-minute Zoom session if you qualify."
    }
  ],
  "post-office.post-office-team.jira-messaging-research-recruitment.screen-space-flags.header": [
    {
      "type": 0,
      "value": "Share your experience for $120 USD"
    }
  ],
  "post-office.post-office-team.push-msg-object-tracking.sample-hello-message.no-translate": [
    {
      "type": 0,
      "value": "Hello, *This is notification test from post office*"
    }
  ],
  "post-office.post-office-team.push-msg-object-tracking.sample-mobile-notification-message.no-translate": [
    {
      "type": 0,
      "value": "Hello, this is a mobile push notification test from post office."
    }
  ],
  "post-office.triggered-ipms.dismiss-button": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "post-office.triggered-ipms.spotlight-body": [
    {
      "type": 0,
      "value": "This is an example you can use to scaffold your own Spotlight experiences."
    }
  ],
  "post-office.triggered-ipms.spotlight-body-1": [
    {
      "type": 0,
      "value": "This is an example you can use to scaffold your own Spotlight Tour experiences."
    }
  ],
  "post-office.triggered-ipms.spotlight-body-2": [
    {
      "type": 0,
      "value": "You can transition between steps with the back, next action handlers."
    }
  ],
  "post-office.triggered-ipms.spotlight-body-3": [
    {
      "type": 0,
      "value": "And complete, or opt out of the tour with the done, and dismiss props."
    }
  ],
  "post-office.triggered-ipms.spotlight-button-back": [
    {
      "type": 0,
      "value": "Back"
    }
  ],
  "post-office.triggered-ipms.spotlight-button-done": [
    {
      "type": 0,
      "value": "Done"
    }
  ],
  "post-office.triggered-ipms.spotlight-button-next": [
    {
      "type": 0,
      "value": "Next"
    }
  ],
  "post-office.triggered-ipms.spotlight-heading": [
    {
      "type": 0,
      "value": "Spotlight Tour Example"
    }
  ]
}